import React from 'react';
import '../Css_files/Placement.css';
import Footer from './Footer';
import Navbar from './Navbar';

const PlacementNews = () => {
  const newsData = [
    {
      id: 1,
      category: 'mechanical',
      title: 'Top Manufacturing Companies Hiring Fresh Graduates',
      excerpt: 'Leading automotive and aerospace companies are actively recruiting mechanical engineers with competitive packages.',
      company: 'Tata Motors, Mahindra, Boeing',
      package: '₹6-12 LPA',
      date: '2024-01-15',
      trending: true
    },
    {
      id: 2,
      category: 'civil',
      title: 'Infrastructure Boom Creates New Opportunities',
      excerpt: 'Government infrastructure projects and smart city initiatives are driving demand for civil engineers.',
      company: 'L&T, Shapoorji Pallonji, DLF',
      package: '₹5-10 LPA',
      date: '2024-01-12',
      trending: false
    },
    {
      id: 3,
      category: 'ece',
      title: '5G Technology Drives ECE Recruitment',
      excerpt: 'Telecom giants are expanding teams for 5G infrastructure development and IoT solutions.',
      company: 'Qualcomm, Ericsson, Nokia',
      package: '₹8-15 LPA',
      date: '2024-01-10',
      trending: true
    },
    {
      id: 4,
      category: 'electronics',
      title: 'Semiconductor Industry Offers Lucrative Roles',
      excerpt: 'With Make in India initiative, electronics companies are offering attractive positions for fresh graduates.',
      company: 'Intel, AMD, Broadcom',
      package: '₹7-14 LPA',
      date: '2024-01-08',
      trending: false
    },
    {
      id: 5,
      category: 'computer',
      title: 'Tech Giants Continue Mass Hiring',
      excerpt: 'Major technology companies are recruiting thousands of software engineers across multiple domains.',
      company: 'Google, Microsoft, Amazon',
      package: '₹12-25 LPA',
      date: '2024-01-05',
      trending: true
    },
    {
      id: 6,
      category: 'arts',
      title: 'Digital Media Companies Expand Creative Teams',
      excerpt: 'Growing demand for digital content creators and multimedia specialists in entertainment industry.',
      company: 'Netflix, Disney, Adobe',
      package: '₹4-8 LPA',
      date: '2024-01-03',
      trending: false
    }
  ];

  const stats = [
    { label: 'Active Recruiters', value: '2,500+', icon: '🏢' },
    { label: 'Job Openings', value: '15,000+', icon: '💼' },
    { label: 'Avg. Package', value: '₹8.5 LPA', icon: '💰' },
    { label: 'Placement Rate', value: '85%', icon: '📈' }
  ];

  const getCategoryColor = (category) => {
    const colors = {
      mechanical: '#FF6B6B',
      civil: '#4ECDC4',
      ece: '#45B7D1',
      electronics: '#96CEB4',
      computer: '#FFEAA7',
      arts: '#DDA0DD'
    };
    return colors[category] || '#666';
  };

  const getCategoryIcon = (category) => {
    const icons = {
      mechanical: '⚙️',
      civil: '🏗️',
      ece: '📡',
      electronics: '🔌',
      computer: '💻',
      arts: '🎨'
    };
    return icons[category] || '📰';
  };

  return (
    <>
    <Navbar/><br></br><br></br><br></br>
    <div className="placement-news-container">
      <header className="news-header">
        <div className="header-content">
          <h1 className="header-title">Placement News & Updates</h1>
          <p className="header-subtitle">
            Stay informed about the latest placement opportunities and industry trends
          </p>
        </div>
        
        <div className="stats-grid">
          {stats.map((stat, index) => (
            <div key={index} className="stat-card" style={{ animationDelay: `${index * 0.1}s` }}>
              <div className="stat-icon">{stat.icon}</div>
              <div className="stat-value">{stat.value}</div>
              <div className="stat-label">{stat.label}</div>
            </div>
          ))}
        </div>
      </header>

      <main className="news-content">
        <div className="news-grid">
          {newsData.map((news, index) => (
            <article key={news.id} className="news-card" style={{ animationDelay: `${index * 0.15}s` }}>
              {news.trending && <div className="trending-badge">🔥 Trending</div>}
              
              <div className="card-header">
                <div className="category-tag" style={{ backgroundColor: getCategoryColor(news.category) }}>
                  <span className="category-icon">{getCategoryIcon(news.category)}</span>
                  <span className="category-name">{news.category.toUpperCase()}</span>
                </div>
                <div className="news-date">{new Date(news.date).toLocaleDateString()}</div>
              </div>

              <div className="card-content">
                <h2 className="news-title">{news.title}</h2>
                <p className="news-excerpt">{news.excerpt}</p>
                
                <div className="news-details">
                  <div className="detail-item">
                    <span className="detail-label">Companies:</span>
                    <span className="detail-value">{news.company}</span>
                  </div>
                  <div className="detail-item">
                    <span className="detail-label">Package:</span>
                    <span className="detail-value package-highlight">{news.package}</span>
                  </div>
                </div>
              </div>

              <div className="card-footer">
                <button className="read-more-btn">Read More</button>
                <div className="action-buttons">
                  <button className="action-btn">👍</button>
                  <button className="action-btn">💾</button>
                  <button className="action-btn">📤</button>
                </div>
              </div>
            </article>
          ))}
        </div>

        <aside className="sidebar">
          <div className="sidebar-section">
            <h3 className="sidebar-title">Quick Tips</h3>
            <ul className="quick-tips">
              <li>Update your resume regularly</li>
              <li>Practice coding interviews</li>
              <li>Build a strong portfolio</li>
              <li>Network with industry professionals</li>
              <li>Stay updated with latest technologies</li>
            </ul>
          </div>

          <div className="sidebar-section">
            <h3 className="sidebar-title">Upcoming Events</h3>
            <div className="events-list">
              <div className="event-item">
                <div className="event-date">Jan 20</div>
                <div className="event-info">
                  <h4>Tech Career Fair</h4>
                  <p>Virtual networking event</p>
                </div>
              </div>
              <div className="event-item">
                <div className="event-date">Jan 25</div>
                <div className="event-info">
                  <h4>Resume Workshop</h4>
                  <p>Expert guidance session</p>
                </div>
              </div>
            </div>
          </div>
        </aside>
      </main>
    </div>
    <Footer/>
    </>
  );
};

export default PlacementNews;